<template>
  <div class="ut-mt-10">
    <section class="ut-mb-8">
      <table class="ut-hidden md:ut-table ut-w-full ut-text-center">
        <thead>
          <tr>
            <th class="ut-w-1/6"></th>
            <th class="ut-w-1/6"></th>
            <th colspan="3" class="ut-w-3/6 ut-bg-green-600 ut-py-4 ut-text-xs ut-font-semibold ut-text-neutral-001 ut-rounded-t-lg ut-bg-green-600 table-title">MOST LIKELY TO LIST</th>
            <th class="ut-w-1/6"></th>
          </tr>
        </thead>
      </table>
      <div class="ut-p-0 ut-card-base">
        <table class="ut-w-full ut-text-center">
          <thead>
            <tr class="ut-text-sm ut-font-semibold">
              <th class="ut-w-1/6"></th>
              <th class="ut-w-1/6 ut-py-8 ut-bg-neutral-020">Total</th>
              <th class="ut-w-1/6 ut-text-neutral-001 ut-bg-green-400">0-30 days</th>
              <th class="ut-w-1/6 ut-text-neutral-001 ut-bg-green-500">31-60 days</th>
              <th class="ut-w-1/6 ut-text-neutral-001 ut-bg-green-400">61-90 days</th>
              <th class="ut-w-1/6 ut-bg-neutral-020">91+ days</th>
            </tr>
          </thead>
          <tbody>
            <tr class="ut-text-3xl ut-border-t ut-border-b ut-border-neutral-040">
              <td class="ut-pl-2 md:ut-pl-10 ut-text-base ut-text-left">Referrals</td>
              <td class="ut-py-12 ut-bg-neutral-020">{{ leadsByCohort.totalReferrals }}</td>
              <td class="ut-text-neutral-001 ut-border-t ut-border-b ut-border-green-600 ut-bg-green-400">{{ stats.referrals[leadCohortBracketType.upTo30] }}</td>
              <td class="ut-text-neutral-001 ut-border-t ut-border-b ut-border-green-600 ut-bg-green-500">{{ stats.referrals[leadCohortBracketType.upTo60] }}</td>
              <td class="ut-text-neutral-001 ut-border-t ut-border-b ut-border-green-600 ut-bg-green-400">{{ stats.referrals[leadCohortBracketType.upTo90] }}</td>
              <td class="ut-bg-neutral-020">{{ stats.referrals[leadCohortBracketType.above90] }}</td>
            </tr>
            <tr class="ut-text-3xl">
              <td class="ut-pl-2 md:ut-pl-10 ut-text-base ut-text-left">Listings</td>
              <td class="ut-py-12 ut-bg-neutral-020">{{ leadsByCohort.totalListingReferrals }}</td>
              <td class="ut-text-neutral-001 ut-bg-green-400">{{ stats.listedReferrals[leadCohortBracketType.upTo30] }}</td>
              <td class="ut-text-neutral-001 ut-bg-green-500">{{ stats.listedReferrals[leadCohortBracketType.upTo60] }}</td>
              <td class="ut-text-neutral-001 ut-bg-green-400">{{ stats.listedReferrals[leadCohortBracketType.upTo90] }}</td>
              <td class="ut-bg-neutral-020">{{ stats.listedReferrals[leadCohortBracketType.above90] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <p class="ut-text-xs ut-text-neutral-300">
      Based on OpenAgent data 40% of referrals will list within 90 days.
    </p>
  </div>
</template>

<script>
import LeadCohortBracketType from '@/Mapper/LeadCohortBracketType';

export default {
  name: 'LeadCohortsOverview',
  props: {
    leadsByCohort: { required: true },
  },
  data() {
    return {
      leadCohortBracketType: LeadCohortBracketType,
    };
  },
  computed: {
    stats() {
      if (!this.leadsByCohort) {
        return null;
      }

      const upTo30 = this.leadsByCohort.cohorts[LeadCohortBracketType.upTo30];
      const upTo60 = this.leadsByCohort.cohorts[LeadCohortBracketType.upTo60];
      const upTo90 = this.leadsByCohort.cohorts[LeadCohortBracketType.upTo90];
      const above90 = this.leadsByCohort.cohorts[LeadCohortBracketType.above90];

      const listedUpTo30 = upTo30.filter(l => l.referralListed === true);
      const listedUpTo60 = upTo60.filter(l => l.referralListed === true);
      const listedUpTo90 = upTo90.filter(l => l.referralListed === true);
      const listedAbove90 = above90.filter(l => l.referralListed === true);

      return {
        referrals: {
          [LeadCohortBracketType.upTo30]: upTo30.length,
          [LeadCohortBracketType.upTo60]: upTo60.length,
          [LeadCohortBracketType.upTo90]: upTo90.length,
          [LeadCohortBracketType.above90]: above90.length,
        },
        listedReferrals: {
          [LeadCohortBracketType.upTo30]: listedUpTo30.length,
          [LeadCohortBracketType.upTo60]: listedUpTo60.length,
          [LeadCohortBracketType.upTo90]: listedUpTo90.length,
          [LeadCohortBracketType.above90]: listedAbove90.length,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.table-title {
  letter-spacing: 0.05rem;
}
</style>
